import store from '@/store';
import { api } from '@p/api';
/**
 * @type {import("vue-router").NavigationGuard}
 */
const guard = async (to, from, next) => {
    const { status, admin } = await api("/test", store);
    if (!status) {
        store.commit('auth/token', null);
        store.commit('auth/admin', false);
        if (to.name != 'Login') {
            next({ name: 'Login' });
            return;
        }
    } else {
        store.commit('auth/admin', admin);
    }
    next();
};
export default guard;
